import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import exportMethod9280c6 from './export'
/**
* @see \App\Http\Controllers\Creator\MemberExportController::__invoke
* @see app/Http/Controllers/Creator/MemberExportController.php:16
* @route '/app/creator/members/export'
*/
export const exportMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

exportMethod.definition = {
    methods: ["get","head"],
    url: '/app/creator/members/export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\MemberExportController::__invoke
* @see app/Http/Controllers/Creator/MemberExportController.php:16
* @route '/app/creator/members/export'
*/
exportMethod.url = (options?: RouteQueryOptions) => {
    return exportMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\MemberExportController::__invoke
* @see app/Http/Controllers/Creator/MemberExportController.php:16
* @route '/app/creator/members/export'
*/
exportMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberExportController::__invoke
* @see app/Http/Controllers/Creator/MemberExportController.php:16
* @route '/app/creator/members/export'
*/
exportMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: exportMethod.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\MemberExportController::__invoke
* @see app/Http/Controllers/Creator/MemberExportController.php:16
* @route '/app/creator/members/export'
*/
const exportMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberExportController::__invoke
* @see app/Http/Controllers/Creator/MemberExportController.php:16
* @route '/app/creator/members/export'
*/
exportMethodForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberExportController::__invoke
* @see app/Http/Controllers/Creator/MemberExportController.php:16
* @route '/app/creator/members/export'
*/
exportMethodForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

exportMethod.form = exportMethodForm

/**
* @see \App\Http\Controllers\Creator\MemberController::show
* @see app/Http/Controllers/Creator/MemberController.php:87
* @route '/app/creator/members/{subscription}'
*/
export const show = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/app/creator/members/{subscription}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\MemberController::show
* @see app/Http/Controllers/Creator/MemberController.php:87
* @route '/app/creator/members/{subscription}'
*/
show.url = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { subscription: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { subscription: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            subscription: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        subscription: typeof args.subscription === 'object'
        ? args.subscription.uuid
        : args.subscription,
    }

    return show.definition.url
            .replace('{subscription}', parsedArgs.subscription.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\MemberController::show
* @see app/Http/Controllers/Creator/MemberController.php:87
* @route '/app/creator/members/{subscription}'
*/
show.get = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberController::show
* @see app/Http/Controllers/Creator/MemberController.php:87
* @route '/app/creator/members/{subscription}'
*/
show.head = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\MemberController::show
* @see app/Http/Controllers/Creator/MemberController.php:87
* @route '/app/creator/members/{subscription}'
*/
const showForm = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberController::show
* @see app/Http/Controllers/Creator/MemberController.php:87
* @route '/app/creator/members/{subscription}'
*/
showForm.get = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberController::show
* @see app/Http/Controllers/Creator/MemberController.php:87
* @route '/app/creator/members/{subscription}'
*/
showForm.head = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Creator\MemberController::cancel
* @see app/Http/Controllers/Creator/MemberController.php:136
* @route '/app/creator/members/{subscription}/cancel'
*/
export const cancel = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: cancel.url(args, options),
    method: 'put',
})

cancel.definition = {
    methods: ["put"],
    url: '/app/creator/members/{subscription}/cancel',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Creator\MemberController::cancel
* @see app/Http/Controllers/Creator/MemberController.php:136
* @route '/app/creator/members/{subscription}/cancel'
*/
cancel.url = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { subscription: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { subscription: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            subscription: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        subscription: typeof args.subscription === 'object'
        ? args.subscription.uuid
        : args.subscription,
    }

    return cancel.definition.url
            .replace('{subscription}', parsedArgs.subscription.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\MemberController::cancel
* @see app/Http/Controllers/Creator/MemberController.php:136
* @route '/app/creator/members/{subscription}/cancel'
*/
cancel.put = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: cancel.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Creator\MemberController::cancel
* @see app/Http/Controllers/Creator/MemberController.php:136
* @route '/app/creator/members/{subscription}/cancel'
*/
const cancelForm = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\MemberController::cancel
* @see app/Http/Controllers/Creator/MemberController.php:136
* @route '/app/creator/members/{subscription}/cancel'
*/
cancelForm.put = (args: { subscription: string | { uuid: string } } | [subscription: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

cancel.form = cancelForm

const members = {
    export: Object.assign(exportMethod, exportMethod9280c6),
    show: Object.assign(show, show),
    cancel: Object.assign(cancel, cancel),
}

export default members